import CoreuiController from "../lib/coreui-controller"
import Autocomplete from "../coreui/autocomplete"

export default class CoreuiAutocompleteController extends CoreuiController {
  static Component = Autocomplete
}
